import { useCallback } from 'react';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';
import { getWorkspaceRoomIds } from 'modules/Workspaces/WorkspacesProvider/utils';
import { getCanonicalParentRoom } from 'utils/roomHierarchyUtils';

const useIsRoomInCurrentWorkspace = () => {
  const { matrixClient } = useMatrixContext();
  const { workspaceId } = useWorkspacesContext();

  const getIsRoomInCurrentWorkspace = useCallback(
    (roomId: string) => {
      if (!workspaceId) return false;
      if (roomId === workspaceId) return true;

      const workspaceRoomIds = getWorkspaceRoomIds(matrixClient, workspaceId);
      if (workspaceRoomIds?.has(roomId)) return true;

      let room = matrixClient.getRoom(roomId);
      while (room) {
        const parent = getCanonicalParentRoom(room);
        if (!parent) return false;
        if (parent.roomId === workspaceId) return true;
        room = parent;
      }

      return false;
    },
    [matrixClient, workspaceId]
  );

  return { getIsRoomInCurrentWorkspace };
};

export default useIsRoomInCurrentWorkspace;
